// extracted by mini-css-extract-plugin
module.exports = {"image":"Ullman_image__2H85p"};